import React, {Component} from 'react';
import {Link} from 'react-router';
import Translate from '../layout/Translate';

export default class Login extends Component {


    componentWillMount() {
        this.loginParams = {
            login: '',
            password: ''
        };

    }


    login() {
        if (!this.props.load) {
            this.props.actions.login(this.loginParams.login, this.loginParams.password);
        }
    }

    changeLogin(field, e) {
        this.loginParams[field] = e.target.value;
    }

    handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.login();
        }
    }

    toggleModal() {
        this.props.actions.toggleLogin();
    }

    render() {
        
        return (

            <div className={"popup " + (this.props.open?'popup_active':'')}>


                <div className="popup__window popup__window_login login">
                    <div className="login__title">
                        <Translate slug="login__title" />
                    </div>
                    <div className="popup__close" onClick={this.toggleModal.bind(this)}></div>
                    
                    {this.props.error &&
                        <div className="login__error"><Translate slug="login__error" /></div>
                    }
                    <input className="login__field" placeholder={this.props.translations.login__email} type="text" name="login" onChange={this.changeLogin.bind(this, 'login')} onKeyPress={this.handleKeyPress.bind(this)} />
                    <input className="login__field" placeholder={this.props.translations.login__password} type="password" name="password" onChange={this.changeLogin.bind(this, 'password')} onKeyPress={this.handleKeyPress.bind(this)} />
                    <input className={"login__button " + (this.props.load?'login__button_progress':'')} type="button" value={this.props.translations.login__submit}  onClick={this.login.bind(this)} />


                </div>
            </div>


        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/popups/Login.js